module.exports = __webpack_public_path__ + "media/assets/images/controlprop-logo-big-56e53f8554a11ba667683fb9aadbcbcb.png";